import { useMemo, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import styles from "./styles/user_management.module.scss";

// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row } from "react-bootstrap";
import CustomTabs from "./Components/CustomTabs.js";
import Header from "./Components/Header.js";
import LimitReps from "./Components/LimitRep.js";
import ReferralAgreements from "./Components/ReferralAgreements.js";
import SignedVault from "./Components/SignedVault.js";
import TabContent from "./Components/TabContent.js";
import Template from "./Components/Template.js";

const AgreementHubManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);

  /**
   * Dummy Data
   */
  const dummyData = [
    {
      id: 1,
      name: "Sarah Johnson",
      brokerage: "Keller Williams",
      status: "Signed",
      state: "TX",
      created: "2024-01-10",
      signed: "2024-01-12",
    },
    {
      id: 2,
      name: "Alex Lee",
      brokerage: "Century 21",
      status: "Pending",
      state: "CA",
      created: "2024-02-05",
      signed: "-",
    },
    {
      id: 3,
      name: "Maria Garcia",
      brokerage: "Realty ONE",
      status: "Completed",
      state: "NY",
      created: "2024-03-15",
      signed: "2024-03-16",
    },
    {
      id: 4,
      name: "David Chen",
      brokerage: "Compass",
      status: "Rejected",
      state: "FL",
      created: "2024-04-01",
      signed: "-",
    },
  ];

  const templateDummyData = [
    {
      id: 1,
      templateName: "California Limited Service Agreement",
      type: "Limited Service",
      state: "California",
      createdDate: "Jan 15, 2025",
      status: "Active",
    },
    {
      id: 2,
      templateName: "Texas Broker-Agent Platform Agreement",
      type: "Broker-Agent Platform Agreement",
      state: "Texas",
      createdDate: "Jan 12, 2025",
      status: "Active",
    },
    {
      id: 3,
      templateName: "Florida Full Service Agreement",
      type: "Broker-Agent Full Service",
      state: "Florida",
      createdDate: "Jan 10, 2025",
      status: "Draft",
    },
    {
      id: 4,
      templateName: "Nevada Referral Agreement V2",
      type: "Referral Agreement",
      state: "Nevada",
      createdDate: "Dec 28, 2024",
      status: "Active",
    },
  ];

  const [activeKey, setActiveKey] = useState("referral");

  const tabs = [
    { key: "referral", label: "Referral Agreements" },
    {
      key: "limited",
      label: "Limited Rep",
    },
    { key: "templates", label: "Templates" },
    { key: "signed", label: "Signed Vault" },
  ];

  // const content = useMemo(() => {
  //   return {
  //     referral: () => <ReferralAgreements data={dummyData} />,
  //     limited: () => <LimitReps data={dummyData} />,
  //     templates: () => <Template data={templateDummyData} />,
  //     signed: () => <SignedVault data={dummyData} />,
  //   };
  // }, [dummyData, templateDummyData]);
  const renderContent = (key) => {
    switch (key) {
      case "referral":
        return <ReferralAgreements data={dummyData} />;
      case "limited":
        return <LimitReps data={dummyData} />;
      case "templates":
        return <Template data={templateDummyData} />;
      case "signed":
        return <SignedVault data={dummyData} />;
      default:
        return null;
    }
  };

  // const { data, isSuccess, isLoading, isFetching, refetch } =
  //   useGetAllUsersQuery(
  //     {
  //       search: searchQuery.length >= 3 ? searchQuery : "",
  //       limit: pageSize,
  //       page: currentPage,
  //       ...(status && status === "all"
  //         ? { is_blocked: "" }
  //         : { is_blocked: status === undefined ? "" : status }),
  //     },
  //     { refetchOnMountOrArgChange: true }
  //   );

  // useEffect(() => {
  //   if (data) {
  //     console.log(data);
  //     setPageSize(data.links.per_page);
  //     setCurrentPage(data.links.current);
  //     setTotalRecords(data.links.total_records);
  //     setTotalPages(data.links.total);
  //     setRowData(data.data);
  //     setDataFetched(true);

  //     if (data.data.length === 0) {
  //       setIndicationMessage("Data not available");
  //     }
  //   }
  // }, [data]);

  // const handleSendCoinModalOpen = () => {
  //   setSendCoinModal(true);
  // };

  // const handleSendCoinModalClose = () => {
  //   setSendCoinModal(false);
  //   setEditedData("");
  // };

  // const handleDeleteModalOpen = () => {
  //   setDeleteModal(true);
  // };

  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <Header title={"Agreement Hub"} />
          </Col>

          <Col md={6}>
            {/* <div className="d-flex justify-content-end align-items-center gap-2">
              <Input
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <SelectFieldComponent
                    firstOption={_.isEmpty(value) ? "Select Status" : value}
                    optionsList={filterData}
                    onSelectChange={onChange}
                  />
                )}
              />
            </div> */}
          </Col>
        </Row>
      </div>
      <br></br>
      {/* TABS */}
      <CustomTabs
        tabs={tabs}
        activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
      />
      {/* TAB CONTENT */}
      <div className="h-100 w-100">
        <TabContent activeKey={activeKey} content={renderContent} />
      </div>
    </div>
  );
};

export default AgreementHubManagementScreen;
